const map = {
	"./asp.net.png": 6156,
	"./azure devops.png": 3507,
	"./back end development.png": 5338,
	"./docker.png": 3703,
	"./elasticsearch.png": 2386,
	"./flask.png": 6254,
	"./front end development.png": 3318,
	"./gcp.png": 2489,
	"./git.png": 5219,
	"./gke.png": 2908,
	"./go.png": 8225,
	"./graphql.png": 5128,
	"./grpc.png": 4855,
	"./html & css.png": 4719,
	"./internet of things (iot).png": 715,
	"./javascript.png": 1586,
	"./kafka.png": 1393,
	"./kubernetes.png": 3615,
	"./laravel.png": 6244,
	"./mysql.png": 6017,
	"./next.js.png": 6765,
	"./postgresql.png": 5477,
	"./python.png": 6117,
	"./react native.png": 9765,
	"./react.png": 2054,
	"./redis queue.png": 9247,
	"./redis.png": 5842,
	"./rest api.png": 7553,
	"./software development.png": 8799,
	"./software engineering.png": 4609,
	"./sql server.png": 4374,
	"./typescript.png": 9154,
	"./websocket.png": 9769
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9352;